<template>
	<v-dialog
		v-model="showDialog"
		max-width="400px"
		@click:outside="showDialog = false"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">部品在庫引き当て</v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="mt-2 ml-2">※在庫表を確認しながら出庫してください</div>
			<v-form class="pa-2" ref="form" lazy-validation>
				<v-row no-gutters class="mt-4" justify="center">
					<v-col cols="12">
						<v-menu
							ref="menu"
							v-model="menu"
							:close-on-content-click="false"
							:nudge-right="40"
							transition="scale-transition"
							offset-y
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									v-model="shippingDate"
									label="出庫予定日"
									readonly
									outlined
									dense
									v-on="on"
									class="px-4"
								></v-text-field>
							</template>
							<v-date-picker
								v-model="shippingDate"
								no-title
								scrollable
								locale="ja"
								@input="menu = false"
							>
							</v-date-picker>
						</v-menu>
					</v-col>

					<v-col cols="12">
						<v-text-field
							v-model="shippingQuantity"
							class="px-4"
							outlined
							dense
							label="出庫予定個数"
						></v-text-field>
					</v-col>
				</v-row>
			</v-form>

			<v-card-actions>
				<v-row no-gutters justify="center" class="pb-2">
					<v-btn color="primary" @click="withdrawStocks()">出庫予定を作成する</v-btn>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import moment from "moment"
import "moment/locale/ja"

export default {
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
		quantity: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			menu: false,
			shippingDate: moment().format("YYYY-MM-DD"),
			shippingQuantity: 0,
		}
	},
	methods: {
		withdrawStocks() {
			const params = {
				shipping_date: this.shippingDate,
				shipping_quantity: this.shippingQuantity,
			}
			this.$emit("withdraw-stocks", params)
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		// TODO functionを使った書き方はしない
		quantity: function (newVal, oldVal) {
			this.shippingQuantity = newVal
		},
	},
}
</script>
